import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";
import { RestaurantDetails, RestaurantFilter } from "../models/List.Restaurant";

@Injectable({
  providedIn: 'root'
})
export class RestaurantService {
  refreshList = new BehaviorSubject<boolean>(false);
  refreshDetails = new BehaviorSubject<boolean>(false);
  createFormSubmitted = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(filter: any): any {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/ResGetOwnBranchesFilter`, filter);
  }
  GetAllMainRestaurants() {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/GetAllMainRestaurants`);
  }

  GetRestaurants(restaurantFilterModel: RestaurantFilter) {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/GetRestaurants`, restaurantFilterModel);
  }
  GetManagers(ResId: number) {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/ResGetManagers?RestaurantId=${ResId}`);
  }
  GetOwneRestaurant() {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/GetOwneRestaurant`);
  }
  // GetAllRestaurant(restaurantId: number): any {
  //   return this.http.post(`${environment.apiUrl}/ResRestaurant/GetAllRestaurant`, restaurantId);
  // }

  GetRestaurantProfile(restaurantId: number | null = null): any {
    if (restaurantId) {
      return this.http.get(`${environment.apiUrl}/ResRestaurant/RestaurantProfile?id=${restaurantId}`);
    } else {
      return this.http.get(`${environment.apiUrl}/ResRestaurant/MainRestaurantProfile`);
    }
  }

  GetDetails(id: number) {
    return this.http.get<RestaurantDetails>(`${environment.apiUrl}/ResRestaurant/RestaurantProfile?id=${id}`);
  }
  SaveAttandanceFeature(data: any) {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/SaveAttandanceFeature`, data);
  }
  saveRecord(data: any, logo: any, banner: any) {
    const formData = new FormData();
    if (logo && logo?.name ) {
      formData.append('Icon', logo, logo?.name);
      // formData.append('bannerPhoto', banner, banner?.name)
    }
    if (banner && banner?.name) {
      // formData.append('Icon', logo, logo?.name);
      formData.append('bannerPhoto', banner, banner?.name)
    }
    formData.append('data', JSON.stringify(data));
    return this.http.post(`${environment.apiUrl}/ResRestaurant/EditRestaurant`, formData);
  }
  EditReservationChannels(data: any) {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/EditReservationChannels`, data);
  }
  GetReservationChannels(restaurantId: number): any {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/GetReservationChannels?RestaurantId=${restaurantId}`);
  }
  saveRestaurantConfig(data: any) {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/ResSaveRestaurantConfig`, data);
  }
  getRestaurantConfig(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/ResGetRestaurantConfig?RestaurantId=${restaurantId}`);
  }

  DeleteRestaurant(restaurantId: number): any {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/DeleteRestaurant?Restaurantid=${restaurantId}`, null);
  }
  GetRestaurantAmenities(restaurantId: number): any {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/GetRestaurantAmenities?RestaurantId=${restaurantId}`);
  }
  SaveRestaurantAmenities(data: any) {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/SaveRestaurantAmenities`, data);
  }
  ReplaceRestaurantManager(data: any, photo: any) {
    const formData = new FormData();
    if (photo && photo.name) {
      formData.append('managerPhoto', photo, photo.name);
    }
    formData.append('data', JSON.stringify(data));
    return this.http.post(`${environment.apiUrl}/ResRestaurant/ResReplaceRestaurantManager`, formData);
  }
  /** Start of Sizes */
  GetAllDiwanSizes() {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/GetAllDiwanSizes`);
  }
  // GetAllRestaurantSizesList(restaurantId: any) {
  //   return this.http.get(`${environment.apiUrl}/ResRestaurant/GetAllRestaurantSizesList?RestaurantId=${restaurantId}`);
  // }
  GetRestaurantSize(restaurantId: any) {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/getRestaurantSize?RestaurantId=${restaurantId}`);
  }
  SaveRestaurantSize(data: any) {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/SaveRestaurantSize`, data);
  }
  /** End of Sizes */
  GetRestaurantShortDetails(id: any) {
    return this.http.get(`${environment.apiUrl}/Restaurant/GetRestaurantShortDetails?id=${id}`);
  }
  RestaurantSizesList(RestaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/GetAllRestaurantSizesList?RestaurantId=${RestaurantId}`);
  }
  PublishRestaurant(id: any) {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/PublishRestaurant?id=${id}`, null);
  }
  GetRestaurantTaxList(RestaurantId: number, menuItemId: number = 0) {
    let query = `?Restaurantid=${RestaurantId}`;
    if (menuItemId) {
      query += `&menuItem=${menuItemId}`;
    }
    return this.http.get(`${environment.apiUrl}/Restaurant/GetRestaurantTaxList${query}`);
  }
}
